import "./ArticlesAndNews.module.css";
import Header from "@/reusable_sections/Header";
import LatestArticles from "./sections/LatestArticles";
import DropATip from "./sections/DropATip";
import Footer from "@/reusable_sections/Footer";
export default function ArticlesAndNewsPage() {
  return <div>
      <Header />
      <LatestArticles />
      <DropATip />
      <Footer />
    </div>;
}